export default __webpack_public_path__ + "static/santi_diving-d624c64333fb837fdc544e985bdfdd7d.jpg";